<template>
  <div class="show">
    <div class="name">
      <span class="name-text">
        {{ show.name }}
      </span>
      <NorticBadge
        v-if="show.id === null"
        class="show-badge"
        theme-type="success"
      >
        Ny
      </NorticBadge>
      <NorticBadge
        v-if="show.hasError.value"
        class="show-badge"
        theme-type="danger"
      >
        Ej giltig
      </NorticBadge>
      <NorticBadge
        v-if="show.hasWarning.value"
        class="show-badge"
        theme-type="warn"
      >
        Kan förbättras
      </NorticBadge>
    </div>
    <div class="location">
      <SvgIcon
        class="icon"
        :data="require('@icons/streamline-icons/Outline version/48-Maps-Navigation/02-Maps/maps-pin-1.svg')"
      />
      {{ locationLabel(show.location) }}
    </div>
    <div class="datetime">
      <SvgIcon
        class="icon"
        :data="require('@icons/streamline-icons/Outline version/01-Interface Essential/18-Time/time-clock-circle-1.svg')"
      />
      {{ startDateLabel(show.startDate) }}
    </div>
  </div>
</template>

<script>
import NorticBadge from '@/components/common/misc/badge/NorticBadge.vue';

export default {
  name: 'NorticSelectShowItemContent',
  components: { NorticBadge },
  props: {
    show: {
      type: Object,
      required: true,
    },
  },
  methods: {
    locationLabel(location) {
      return `${location?.name || 'Spelplats ej angiven'}, ${location?.city || 'Stad ej angiven'}`;
    },
    startDateLabel(startDate) {
      return `${startDate?.date || 'Datum ej angivet'}, ${startDate?.time || 'Tid ej angivet'},`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .show {
    display: grid;
    grid-gap: 0.3em;
    overflow: hidden;

    .name {
      font-weight: 500;
      overflow: hidden;
      white-space: nowrap;
      display: inline-flex;

      .name-text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 2px 0;
      }

      .show-badge {
        margin-left: 5px;
      }
    }

    .datetime,
    .location {
      display: grid;
      grid-template-columns: min-content 1fr;
      grid-gap: 1em;
      align-items: center;
      font-size: 0.8em;
      color: var(--primary-text-discrete-hex);

      .icon {
        font-size: 1.25em;
        color: var(--primary-text-alt-color-hex);
      }
    }
  }
</style>
